import React from "react";

function FooterSection() {
  return (
    <>
    <div className="h-[50px] bg-black block md:hidden w-full flex items-center justify-center text-white text-sm">
      © 2025 Hisab-Kitab. All rights reserved.
    </div>
    </>
  );
}

export default FooterSection;
